<template>
  <div class="form-base">
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Полное наименование"
          outlined
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"           
        />
      </v-col>

      <v-col cols="6">
        <DadataOrgField
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          mask="#############"
          label="ОГРН"
          outlined
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"           
        />
      </v-col>
      <v-col cols="6">
        <DadataOrgField
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          mask="##########"
          label="ИНН"
          outlined
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"           
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { EMOJI, getValidationErrorText, INN_ROD, OGRN } from '@/utils/validate';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import DadataOrgField from '@/components/base/DadataOrgField';

export const proxyPersonOrganizationModel = {
  name: '',
  ogrn: '',
  inn: '',
};

export const proxyPersonOrganizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  ogrn: {
    required,
    minLength: minLength(13),
    OGRN,
  },
  inn: {
    minLength: minLength(10),
    INN: INN_ROD,
  },
};

export default {
  name: 'ProxyPersonOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DadataOrgField,
  },  
  data: () => ({
    suggestions: [],    
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
    }
  }    
};
</script>
